import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <UpdatesSection />
        <FaqSection />
        <MediaSection />
        <ContactSection />
        <CommentsSection />
        <CarouselSection />
        <RankingSection />
        <AppSection />
        <IndexSection />
        <FeaturesSection />
        <TopicsSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}